import { useQuery } from '@tanstack/react-query';
import { recoveryApi, type RecoveryStatus } from '@/services/recoveryApi';

/**
 * React Query hook to check recovery status for a user.
 * Returns what's missing (bio, learning path, survey data) and what actions are needed.
 *
 * Cached for 5 minutes — recovery status doesn't change frequently.
 */
export const recoveryKeys = {
  all: ['recovery'] as const,
  status: (userId: string) => [...recoveryKeys.all, 'status', userId] as const,
  regenerateStatus: (userId: string, correlationId?: string) =>
    [...recoveryKeys.all, 'regenerate', userId, correlationId] as const,
};

export function useRecoveryStatus(userId: string | undefined, enabled = true) {
  return useQuery<RecoveryStatus>({
    queryKey: recoveryKeys.status(userId || ''),
    queryFn: () => recoveryApi.getStatus(userId!),
    enabled: enabled && !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}
